import React from "react";
import * as S from "../css/Vass.styles";
import MenuComponent from "../component/MenuComponent";
// import MenuComponentViewer from "../component/MenuComponentViewer";
import VassComponent1 from "../component/vass/VassComponent1";
import VassComponent2 from "../component/vass/VassComponent2";
import { vassViewState } from "../stores/vass/vassViewState";
import { useRecoilValue } from "recoil";
function Vass(props) {
  const VassView = useRecoilValue(vassViewState); // Vass 페이지 레이아웃 선택
  return (
    <S.DashboardContainer>
      <MenuComponent theme={props.theme} />
      <S.ContentContainer>
        {VassView === "1" && <VassComponent1 theme={props.theme} />} {/* 화면 1개만 보기 */}
        {VassView === "2" && <VassComponent2 theme={props.theme} />} {/* 화면 분할로 보기 */}
      </S.ContentContainer>
    </S.DashboardContainer>
  );
}

export default Vass;
